module.exports = __webpack_public_path__ + "static/p-ndodok-lawang-8d6720e07aa4305b41681247cb8802f1.jpg";